<template>
  <div>
    <h1>
      {{projectType | capitalize}} Application Revision Search
    </h1>

    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <base-input v-model="applicationNumber"
                      label="Application Number"
                      v-on:keyup.enter="searchAppNumber">
          </base-input>
        </div>
        <button class="btn btn-primary" @click="searchAppNumber">Search</button>
      </div>
    </div>

  </div>
</template>

<script>
import BaseInput from '~/components/BaseInput';
import { CapitalizeFilter } from '@/js/Mixins';
import { getRevisionApplication } from '~/js/FormFunctions';

export default {
  name: 'RevisionSearch',
  props: ['projectType'],
  components: { BaseInput },
  mixins: [CapitalizeFilter],
  data() {
    return {
      applicationNumber: null,
      fetchingData: false,
    };
  },
  methods: {
    searchAppNumber() {
      const self = this;
      this.fetchingData = true;

      getRevisionApplication(this.applicationNumber)
        .then((data) => {
          self.fetchingData = false;
          const form = data;
          if (!form.projectType) {
            form.projectType = 'Demolition';
          }
          self.$store.commit('temporaryForm', data);

          if (form.projectOMUpdate || form.revisionCount < 6) {
            self.$router.push({ name: 'RevisionSelect', params: { projectType: data.projectType.toLowerCase(), id: self.applicationNumber } });
          } else {
            self.$router.push({
              name: 'RevisionInvalid',
              params: {
                projectType: data.projectType.toLowerCase(),
              },
            });
          }
        })
        .catch(() => {
          self.fetchingData = false;
        });
    },
  },
};
</script>
